module.exports = __webpack_public_path__ + "553c822496f37d4e22060f71c056526b.svg";